import { render, staticRenderFns } from "./lkuPangkat.vue?vue&type=template&id=612330d6&"
import script from "./lkuPangkat.vue?vue&type=script&lang=js&"
export * from "./lkuPangkat.vue?vue&type=script&lang=js&"
import style0 from "./lkuPangkat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports